import { createAttendee } from './utils-module.js';
import {
  isNeedToShowPrivacy,
  initRegForm,
  initSubmitButton,
  getErrorRegFallBecauseOfAttendeeNull,
  initPrivacyPolicyLink,
  prepareRegPage,
} from './registration/index.js';
import { validatePageParams, validationVariants, fetchData } from './page.js';
import { setBackground, setLogo } from './customizePage/registration.js';
import { redirectToPage } from './page-routes.js';
import multiAccounts from './multiAccounts/index.ts';
import { findAttendeeByUIDAndEventId } from '../../../packages/src/api/index.js';
import { calculateExpiredDate } from './multiAccounts/data.ts';
import { saveLocParams, initLoc } from './localization.js';
import { initEventOrganisationDataStorage } from '../../../packages/src/eventOrganisationDataStorage.js';

const eventOrganisationDataStorage = initEventOrganisationDataStorage();
const { isSetUpEventName } = validationVariants;

const form = initRegForm();

async function init() {
  prepareRegPage();

  if (!validatePageParams([isSetUpEventName])) {
    return;
  }

  initPrivacyPolicyLink();

  const event = await fetchData.event();
  if (!event) return;

  const { opts } = event;

  saveLocParams({ orgId: event.organisation?.id, eventCode: event.name });
  await initLoc();

  if (event.organisation) {
    eventOrganisationDataStorage.storeEventOrganisationData(event.organisation);
  }

  const { submitButton, submitButtonText } = initSubmitButton();

  setLogo(opts.webappCustomLogoSrc);
  setBackground(opts.webappCustomBackgroundSrc);

  if (opts.webappIsEnabledSMS) {
    form.enablePhoneNumber(opts.webappSMSAgreement);
  }

  if (isNeedToShowPrivacy(opts)) {
    form.enableAgreePrivacy();
  }

  form.onSubmit(async ({ name, email, phoneNumber }) => {
    if (submitButton) {
      submitButton.textContent = 'Loading...';
    }
    try {
      const { result: attendeeUid } = await createAttendee({
        eventCode: event.name,
        name,
        email,
        phoneNumber,
      });
      if (!attendeeUid) {
        if (submitButton) {
          submitButton.textContent = submitButtonText;
          submitButton.disabled = false;
        }
        alert(getErrorRegFallBecauseOfAttendeeNull({ canBeEmailConfirmationProblem: true }));
        return;
      }
      const { result: attendee } = await findAttendeeByUIDAndEventId(attendeeUid, event.id);
      multiAccounts.addAccount({
        attendeeUid,
        eventCode: event.name,
        eventLogo: opts.webappCustomLogoSrc,
        name,
        email,
        phoneNumber,
        regDate: attendee.created_date,
        expireDate: calculateExpiredDate(event, attendee),
      });
      multiAccounts.setCurrentAccount(0);
      redirectToPage.index({ rawSearch: window.location.search });
    } catch (error) {
      console.error('Error creating attendee:', error);
      if (submitButton) {
        submitButton.textContent = submitButtonText;
        submitButton.disabled = false;
      }
      throw error;
    }
  });
}

document.addEventListener('DOMContentLoaded', init);
